/* @ngInject */
const wagon = (
  wagonNew,
  wagonLocal,
  wagonGo,
  wagonFormat,
  wagonMetadata,
  wagonData,
  wagonAsk,
  wagonRequest,
  wagonTest,
  wagonLabels
) => {
  const self = {}

  self.new = wagonNew
  self.go = wagonGo
  self.local = wagonLocal
  self.format = wagonFormat
  self.metadata = wagonMetadata
  self.data = wagonData
  self.test = wagonTest
  self.ask = wagonAsk
  self.request = wagonRequest
  self.labels = wagonLabels

  return self
}

export default wagon



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/trains/wagon/services/wagon.service.js